import { InputQuantityProps } from './types'
import { InputDecimal } from '../decimalInput'

export function LoadingQuantityInput({
  disabled,
  inputId,
  onChangeValue,
  required,
  value
}: InputQuantityProps) {
  return (
    <div className='grid grid-cols-12 gap-2'>
      <div className='col-span-8'>
        <InputDecimal
          disabled={disabled}
          id={inputId}
          name={`${inputId}-quantity`}
          onChange={onChangeValue}
          required={required}
          value={value?.value?.toString()}
        />
      </div>
      <div className='col-span-4' />
    </div>
  )
}
